import { SyncLoader, PuffLoader } from 'react-spinners'
import React from 'react'

import { getSmartSize } from '../../utils/helpers/styles'
import { useColor } from '../theme/_hooks/colors'
import Center from './Center'

const SIZES = {
  xsmall: 0.2,
  small: 0.3,
  normal: 0.4,
  medium: 0.5,
  large: 0.6
}

const Loading = ({ color, size, type, ...props }) => {
  const colorValue = useColor(color || 'dark3')
  const sizeValue = getSmartSize(size, SIZES, 'normal')

  const Loader = type === 'spin' ? PuffLoader : SyncLoader

  return (
    <Center flex={1} {...props}>
      <Loader color={colorValue} loading size={sizeValue} />
    </Center>
  )
}

export default Loading
